import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TestReport } from "@sandbox/code-editor";

interface TestState {
  report?: TestReport[];
}

const initialState: TestState = {
}

export const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    testReportGenerated: (state, { payload }: PayloadAction<TestReport[]>) => {
      state.report = payload;
    },
  }
});

// Action creators are generated for each case reducer function
export const {
  testReportGenerated,
} = testSlice.actions;

export default testSlice.reducer;
